import { render, staticRenderFns } from "./admin_package.vue?vue&type=template&id=02d704d8&scoped=true&"
import script from "./admin_package.vue?vue&type=script&lang=ts&"
export * from "./admin_package.vue?vue&type=script&lang=ts&"
import style0 from "./admin_package.vue?vue&type=style&index=0&id=02d704d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d704d8",
  null
  
)

export default component.exports